
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { RequestsService } from '@app/services/requests.service';
import { HelpCenter } from '@app/app.definitions';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: "sb-knowledge-page",
  templateUrl: "./knowledge.component.html",
  styleUrls: ["./knowledge.component.scss"]
})

export class KnowledgeComponent implements OnInit {


  subpageId: string;
  content: string;
  helpCenters: HelpCenter;

  constructor(private route: ActivatedRoute, private http: HttpClient,
    private sanitizer: DomSanitizer,
    private requestService: RequestsService) { }

  ngOnInit(): void {

    this.route.params.subscribe(paramsId => {

      this.requestService.getHelpCenter(paramsId.helpslug)
        .then((helpCenters: HelpCenter) => {
          this.helpCenters = helpCenters;
          this.helpCenters.description = this.sanitizer.bypassSecurityTrustHtml(this.helpCenters.description);
        },
          error => {
            console.error(error); 
          });
    });  
  }


}
